import { RequestDashboardTable, RequestDashboardTableConfig } from '../../request-dashboard/scripts/request-dashboard.table';

export class RequestReviewPage {
    requestTable: RequestDashboardTable;
    tableConfig: RequestDashboardTableConfig;

    constructor() {
        $(() => {
            this.tableConfig = {
                tableContainerId: "request-review-content",
                getRoute: "/secure/biospecimens/sample-request-form/request-review-dashboard/request-review-dashboard?handler=Applications",
                loadingContainerId: "loading-content-container",
                loadedContentId: "loaded-request-review-content",
                isEditable: false,
                isReviewer: true,
                tableVarName: "requestTable"
            }
            this.requestTable = new RequestDashboardTable(this.tableConfig);
        });
    }
}